// Compare eshop and Bookshelf router.js when either router changes.
// Last checked: 2026-10-14. Detail routes are listed separately from their roots.
export default [
  '/care-dizw-dwra (Δώρα Care-δίζω)',
  '/promos και /promos/… (promo pages, π.χ. /promos/black-friday)',
  '/contests και /contests/… (διαγωνισμοί)',
  '/upcoming-products',
  '/blog/authors',
  '/login και /login/…',
  '/profile/referral',
  '/invite/…',
  '/claim-points/…',
  '/track-order/…',
];
